/* eslint-disable no-restricted-globals */
import { dwmRepository } from 'common/repositories/index';
import Alert from 'directives/dashboard/ui-alert/-RFC.ui-alert-logic';
import Mixpanel from 'common/services/stats/-RFC.Mixpanel';

const _serviceDependencies = ['$scope', '$http', '$rootScope', 'Util'];

class DwmPhoneNumbers {

    constructor($scope, $http, $rootScope, Util) {

        $scope.selectedDevice = $scope.selectedDevice || {};
        $scope.phoneNumberIsValid = false;
        $rootScope.phoneNumberErrorDWM = false;

        const onDwmDataNext = () => {

            const assets = dwmRepository.getAll('assets') || {};
            if (assets.primaryMember) {

                $scope.phoneNumbers = assets.primaryMember.monitoredAccounts.phoneNumbers;

                $scope.phoneNumbers.entries.forEach((entry) => {

                    if (entry.countryCallingCode === null && entry.countryCode === 'DE') {

                        entry.countryCallingCode = '49';

                    }

                    entry.showUpdateInput = false;

                });

            }

        };

        const dwmRepositoryObservable = dwmRepository.getObservable();
        dwmRepositoryObservable
            .subscribe(
                data => onDwmDataNext(data),
                () => { },
                () => { },
            );

        $scope.newEntryVisible = false;
        $scope.showAddNewButton = true;
        $scope.showSaveButton = false;
        $scope.showRemoveEntryScreen = false;
        $scope.showUpdateButton = false;

        $scope.addNewEntry = () => {

            $scope.newEntryVisible = true;
            $scope.showAddNewButton = false;
            $scope.showSaveButton = true;

        };

        $scope.cancelNewEntry = () => {

            $rootScope.phoneNumberErrorDWM = false;
            $scope.newEntryVisible = false;
            $scope.showAddNewButton = true;
            $scope.showSaveButton = false;
            $scope.newPhoneNumber = '';
            $scope.selectedDevice = {};
            $scope.newEntrySubmitted = false;

        };

        $scope.updateEntry = (index) => {

            $scope.newEntryVisible = false;
            $scope.showAddNewButton = false;
            $scope.showSaveButton = false;
            $scope.showUpdateButton = true;

            $scope.phoneNumbers.entries.forEach((entry, loopIndex) => {

                if (index === loopIndex) {

                    entry.showUpdateInput = true;
                    $scope.updateEntryPayload = entry;
                    $scope.updateEntryIndex = index;

                    // Save initial phone number to use in case of update with the same value
                    $scope.initialPhoneNumber = entry.phoneNumber;

                    // Save the entry values to autofill country-selector
                    $scope.selectedDevice = {
                        phoneNumber: entry.phoneNumber,
                        country: {
                            code: entry.countryCode.toLowerCase(),
                            dialCode: `+${entry.countryCallingCode}`,
                        },
                    };

                } else {

                    entry.showUpdateInput = false;

                }

            });

        };

        $scope.cancelUpdateNewEntry = () => {

            $scope.showAddNewButton = true;
            $scope.showUpdateButton = false;
            $rootScope.phoneNumberErrorDWM = false;

            $scope.phoneNumbers.entries.forEach((entry) => {

                entry.showUpdateInput = false;

            });

            $scope.updateEntryPayload = {};
            $scope.selectedDevice = {};

        };

        $scope.validatePhoneNumber = () => {

            const countryCode = $scope.selectedDevice.country ?
                $scope.selectedDevice.country.code.substring(0, 2) : '';

            // Check if the phone number is from international calling zone 1 and add to phoneNumber
            const isZoneOne = $scope.selectedDevice.country.dialCode.indexOf('+1 ') > -1;
            const phoneNumberZoneOne = isZoneOne ?
                $scope.selectedDevice.country.dialCode.substring(3).concat($scope.selectedDevice.phoneNumber) : '';

            const isValidNumber = isZoneOne ?
                Util.isValidPhoneNumber(phoneNumberZoneOne, countryCode) :
                Util.isValidPhoneNumber($scope.selectedDevice.phoneNumber, countryCode);

            $scope.newPhoneNumber = $scope.selectedDevice.phoneNumber;
            $scope.countryCode = countryCode.toUpperCase();

            const phoneExists = $scope.phoneNumbers.entries
                .find(phone => phone.countryCode === $scope.countryCode &&
                phone.phoneNumber === $scope.newPhoneNumber);

            $scope.phoneExistsError = phoneExists;
            return isValidNumber && !phoneExists;

        };

        $scope.saveNewEntry = () => {

            $scope.phoneNumberIsValid = $scope.validatePhoneNumber();
            $scope.newEntrySubmitted = true;

            if ($scope.phoneNumberIsValid) {

                $scope.saveNewPhoneIsLoading = true;
                $rootScope.phoneNumberErrorDWM = false;
                let payload;
                if ($scope.phoneNumbers.entries.length === 0) {

                    payload = {
                        primaryPhone: {
                            phoneNumber: $scope.newPhoneNumber,
                            countryCode: $scope.countryCode,
                            type: 'Mobile',
                            isPrimaryPhoneEmpty: true,
                        },
                    };

                } else {

                    payload = {
                        phoneNumbers: {
                            phoneNumber: $scope.newPhoneNumber,
                            countryCode: $scope.countryCode,
                            type: 'Mobile',
                        },
                    };

                }

                $http({
                    method: 'POST',
                    url: `${CWCONFIG.dwm.restApi}/v1/modifyAccount`,
                    headers: {
                        client_id: 'avira',
                        origin: 'https://avira.com',
                        access_token: $rootScope.dwmNortonToken,
                        'Content-Type': 'application/json',
                    },
                    data: payload,

                }).then(() => {

                    $scope.newPhoneNumber = '';
                    $scope.saveNewPhoneIsLoading = false;

                    $http({
                        method: 'GET',
                        url: `${CWCONFIG.dwm.restApi}/v1/partner/members`,
                        headers: {
                            client_id: 'avira',
                            origin: 'https://avira.com',
                            access_token: $rootScope.dwmNortonToken,
                            'Content-Type': 'application/json',
                        },

                    }).then((membersResponse) => {

                        dwmRepository.replace('assets', membersResponse.data);

                        const { monitoredAccounts, dwmCardStatus } =
                            membersResponse.data.primaryMember;

                        Mixpanel.setCommonProperty('AIA Asset Phone', monitoredAccounts.phoneNumbers.entries.length);

                        Mixpanel.send('ConnectWeb AIA Entry Action Success', {
                            Action: 'Add',
                            Entry: 'Phone numbers',
                        });

                        if (dwmCardStatus === 'add-more-data') {

                            $rootScope.showDwmCardHomepage = true;
                            $rootScope.showDwmAddMoreDataCard = true;

                        } else {

                            $rootScope.showDwmCardHomepage = false;

                        }

                        $scope.cancelNewEntry();

                    });

                }).catch((responseError) => {

                    $scope.saveNewPhoneIsLoading = false;

                    if (responseError.data) {

                        if (responseError.data.errorCode === 4013) {

                            Alert.error('cw.dwm.dupliacte_entry_error');

                        } else {

                            Alert.error(
                                { message: 'cw.recommendation.error.connection_failed' },
                                {
                                    message: {
                                        brandname: CWCONFIG.partnerConfig.name,
                                        url: '/dashboard/support/tabs/support',
                                    },
                                },
                            );

                        }

                    }

                });

            } else {

                $rootScope.phoneNumberErrorDWM = true;

            }

        };

        $scope.removeEntry = (index) => {

            $scope.showRemoveEntryScreen = true;
            $scope.cancelNewEntry();

            $scope.removeEntryPayload = {
                phoneNumbers:
                {
                    id: $scope.phoneNumbers.entries[index].id,
                },
            };

        };

        $scope.confirmRemoveEntry = () => {

            $scope.confirmRemoveIsLoading = true;

            $http({
                method: 'DELETE',
                url: `${CWCONFIG.dwm.restApi}/v1/modifyAccount?payload=${encodeURIComponent(JSON.stringify($scope.removeEntryPayload))}`,
                headers: {
                    client_id: 'avira',
                    origin: 'https://avira.com',
                    access_token: $rootScope.dwmNortonToken,
                    'Content-Type': 'application/json',
                },
            }).then(() => {

                $scope.newPhoneNumber = '';
                $http({
                    method: 'GET',
                    url: `${CWCONFIG.dwm.restApi}/v1/partner/members`,
                    headers: {
                        client_id: 'avira',
                        origin: 'https://avira.com',
                        access_token: $rootScope.dwmNortonToken,
                        'Content-Type': 'application/json',
                    },

                }).then((membersResponse) => {

                    dwmRepository.replace('assets', membersResponse.data);

                    const { monitoredAccounts, dwmCardStatus } = membersResponse.data.primaryMember;
                    Mixpanel.setCommonProperty('AIA Asset Phone', monitoredAccounts.phoneNumbers.entries.length);

                    Mixpanel.send('ConnectWeb AIA Entry Action Success', {
                        Action: 'Delete',
                        Entry: 'Phone numbers',
                    });

                    if (dwmCardStatus === 'add-more-data') {

                        $rootScope.showDwmCardHomepage = true;
                        $rootScope.showDwmAddMoreDataCard = true;

                    } else {

                        $rootScope.showDwmCardHomepage = false;

                    }

                    $scope.confirmRemoveIsLoading = false;
                    $scope.cancelRemoveEntry();
                    $scope.cancelUpdateNewEntry();

                });

            }).catch((responseError) => {

                $scope.confirmRemoveIsLoading = false;

                if (responseError.data) {

                    Alert.error(
                        { message: 'cw.recommendation.error.connection_failed' },
                        {
                            message: {
                                brandname: CWCONFIG.partnerConfig.name,
                                url: '/dashboard/support/tabs/support',
                            },
                        },
                    );

                }

            });

        };

        $scope.cancelRemoveEntry = () => {

            $scope.showRemoveEntryScreen = false;
            $scope.removeEntryPayload = {};

        };

        $scope.saveUpdatedEntry = () => {

            $scope.phoneNumberIsValid = $scope.validatePhoneNumber();
            $scope.saveUpdatedEntryIsLoading = true;

            if ($scope.phoneNumberIsValid &&
                $scope.newPhoneNumber !== $scope.initialPhoneNumber) {

                $rootScope.phoneNumberErrorDWM = false;
                $scope.updateEntryPayload.phoneNumber = $scope.newPhoneNumber;
                $scope.updateEntryPayload.countryCode = $scope.countryCode;

                let data;
                if ($scope.updateEntryIndex === 0) {

                    data = {
                        primaryPhone: {
                            phoneNumber: $scope.updateEntryPayload.phoneNumber,
                            type: 'MOBILE',
                            countryCode: $scope.updateEntryPayload.countryCode,
                            isPrimaryPhoneEmpty: false,
                        },

                    };

                } else {

                    data = {
                        phoneNumbers: $scope.updateEntryPayload,
                    };

                }

                $http({
                    method: 'PUT',
                    url: `${CWCONFIG.dwm.restApi}/v1/modifyAccount`,
                    headers: {
                        client_id: 'avira',
                        origin: 'https://avira.com',
                        access_token: $rootScope.dwmNortonToken,
                        'Content-Type': 'application/json',
                    },
                    data,
                }).then(() => {

                    Mixpanel.send('ConnectWeb AIA Entry Action Success', {
                        Action: 'Update',
                        Entry: 'Phone numbers',
                    });

                    $scope.showAddNewButton = true;
                    $scope.showUpdateButton = false;
                    $scope.updateEntryPayload = {};
                    $scope.saveUpdatedEntryIsLoading = false;

                    $http({
                        method: 'GET',
                        url: `${CWCONFIG.dwm.restApi}/v1/partner/members`,
                        headers: {
                            client_id: 'avira',
                            origin: 'https://avira.com',
                            access_token: $rootScope.dwmNortonToken,
                            'Content-Type': 'application/json',
                        },

                    }).then((membersResponse) => {

                        dwmRepository.replace('assets', membersResponse.data);
                        $scope.confirmRemoveIsLoading = false;

                    });

                }).catch((responseError) => {

                    $scope.saveUpdatedEntryIsLoading = false;

                    if (responseError.data) {

                        if (responseError.data.errorCode === 4013) {

                            Alert.error('cw.dwm.dupliacte_entry_error');

                        } else {

                            Alert.error(
                                { message: 'cw.recommendation.error.connection_failed' },
                                {
                                    message: {
                                        brandname: CWCONFIG.partnerConfig.name,
                                        url: '/dashboard/support/tabs/support',
                                    },
                                },
                            );

                        }

                    }

                });

            } else {

                $scope.saveUpdatedEntryIsLoading = false;
                $rootScope.phoneNumberErrorDWM = true;

            }

        };

    }

}

_serviceDependencies.push(DwmPhoneNumbers);

angular.module('controllers')
    .controller('DwmPhoneNumbers', _serviceDependencies);



// WEBPACK FOOTER //
// ./scripts/controllers/modals/dwm/phone-numbers/phone-numbers.js